module.exports = __webpack_public_path__ + "static/media/call.5ade3d47.png";